import { SubscriptionId } from 'types';

export const CLIENT_SUBSCRIPTIONS = '/api/v1/subscriptions/for-admin';
export const CLIENT_SUBSCRIPTION = (subscriptionId: SubscriptionId) =>
    `/api/v1/subscriptions/for-admin/${subscriptionId}`;
export const ADD_CLIENT_SUBSCRIPTION = '/api/v1/subscriptions/for-admin/activate';
export const BLOCK_CLIENT_SUBSCRIPTION = '/api/v1/subscriptions/for-admin/block';
export const VERIFY_INSTITUTION = '/api/v1/subscriptions/for-admin/verify';
export const DELETE_INSTITUTION = '/api/v1/subscriptions/for-admin/delete';
